import { MessageCircle, Wifi, Wind, Utensils, Car, Tv, Droplet } from "lucide-react";
import BookingForm from "../components/BookingForm";

const WHATSAPP_NUMBER = "60195960498";
const whatsappLink = (msg: string) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

const amenities = [
  { icon: Wifi, label_ms: "WiFi Percuma" },
  { icon: Wind, label_ms: "Penghawa Dingin (2 bilik)" },
  { icon: Utensils, label_ms: "Dapur Lengkap" },
  { icon: Car, label_ms: "Parking Dalam Pagar" },
  { icon: Tv, label_ms: "TV" },
  { icon: Droplet, label_ms: "Tuala Disediakan" },
];

const gallery = [
  "/images/exterior-gate.jpeg",
  "/images/living-room-1.jpeg",
  "/images/living-room-2.jpeg",
  "/images/living-room-3.jpeg",
  "/images/kitchen.jpeg",
  "/images/bedroom-1.jpeg",
  "/images/bedroom-2.jpeg",
  "/images/bedroom-3.jpeg",
  "/images/bathroom-1.jpeg",
  "/images/bathroom-2.jpeg",
];

export default function Home() {
  return (
    <div className="min-h-screen bg-sand-50 text-sea-700">
      <header className="flex items-center justify-between px-6 py-4 bg-white shadow-sm sticky top-0 z-10">
        <span className="font-bold text-xl text-sea-600">Rumah Pantai Homestay</span>
        <a
          href="#tempahan"
          className="rounded-full bg-sea-500 text-white px-5 py-2 font-medium hover:bg-sea-600 transition"
        >
          Tempah Sekarang
        </a>
      </header>

      <section className="relative">
        <img
          src="/images/exterior-gate.jpeg"
          alt="Rumah Pantai Homestay"
          className="w-full h-72 sm:h-96 object-cover"
        />
        <div className="absolute inset-0 bg-black/30 flex flex-col items-center justify-center text-white text-center px-4">
          <h1 className="text-3xl sm:text-5xl font-bold">Rumah Pantai Homestay</h1>
          <p className="mt-2 text-lg">Kemaman, Terengganu &middot; Bermula RM170 semalam</p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 py-10">
        <h2 className="text-2xl font-bold mb-4">Kemudahan Utama</h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
          {amenities.map(({ icon: Icon, label_ms }) => (
            <div key={label_ms} className="flex items-center gap-2 bg-white rounded-lg p-3 shadow-sm">
              <Icon className="text-turquoise-500" size={22} />
              <span className="text-sm font-medium">{label_ms}</span>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 py-10">
        <h2 className="text-2xl font-bold mb-4">Galeri</h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {gallery.map((src) => (
            <img
              key={src}
              src={src}
              loading="lazy"
              alt="Rumah Pantai Homestay"
              className="w-full h-40 object-cover rounded-lg"
            />
          ))}
        </div>
      </section>

      <section id="tempahan" className="max-w-4xl mx-auto px-6 py-10">
        <h2 className="text-2xl font-bold mb-4">Semak Tarikh & Tempah</h2>
        <BookingForm />
      </section>

      <section className="max-w-4xl mx-auto px-6 py-10">
        <h2 className="text-2xl font-bold mb-4">Polisi</h2>
        <ul className="list-disc list-inside space-y-1 text-sea-700">
          <li>Check-in: 2:00 PM &middot; Check-out: 12:00 PM</li>
          <li>Tiada deposit diperlukan</li>
          <li>Boleh batal bila-bila masa tanpa caj</li>
        </ul>
      </section>

      <section className="max-w-4xl mx-auto px-6 py-10">
        <h2 className="text-2xl font-bold mb-4">Self Check-in</h2>
        <div className="bg-white rounded-xl p-6 shadow-sm text-sea-700 space-y-2 text-sm">
          <p>Kami menyediakan perkhidmatan self check-in melalui key box. Pilih salah satu:</p>
          <ol className="list-decimal list-inside space-y-1">
            <li>
              <strong>Bank in</strong> — pindahan ke akaun yang akan diberikan selepas tempahan
              disahkan, kemudian hantar resit melalui WhatsApp.
            </li>
            <li>
              <strong>Cash / Touch n Go eWallet</strong> — hantar gambar IC melalui WhatsApp, dan
              tinggalkan wang dalam key box sebelum check-out, atau scan QR dan bayar terus.
            </li>
          </ol>
          <p>Kod key box akan dihantar selepas pembayaran disahkan oleh admin.</p>
          {/*
            KEPUTUSAN DIREKA BENTUK (disahkan oleh pemilik): nombor akaun bank, QR pembayaran
            dan kod key box TIDAK dipaparkan secara terbuka di halaman ini. Butiran tersebut
            hanya dijana secara automatik pada halaman /tempahan/ringkasan/:ref dan /semakan
            SELEPAS booking.status = CONFIRMED (Fasa 5) — dibaca dari site_settings melalui
            endpoint admin-gated, bukan dibina ke dalam bundle frontend awam.
          */}
        </div>
      </section>

      <a
        href={whatsappLink("Hai, saya berminat untuk menempah Rumah Pantai Homestay.")}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-5 right-5 bg-green-500 text-white rounded-full p-4 shadow-lg hover:bg-green-600 transition"
        aria-label="Hubungi kami melalui WhatsApp"
      >
        <MessageCircle size={26} />
      </a>

      <footer className="bg-sea-700 text-white text-center py-6 mt-10 text-sm">
        <p>No 4837, Jalan Geliga Pantai 3, Kampung Geliga Besar, 24000 Kemaman, Terengganu</p>
        <p>WhatsApp: 019-596 0498</p>
      </footer>
    </div>
  );
}
